import { render } from "./CouponDetail.vue?vue&type=template&id=629a7b71&scoped=true"
import script from "./CouponDetail.vue?vue&type=script&lang=js"
export * from "./CouponDetail.vue?vue&type=script&lang=js"

import "./CouponDetail.vue?vue&type=style&index=0&id=629a7b71&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629a7b71"]])

export default __exports__